import { Card, CardKind, LevelSim } from "@highmarch/domain";

/** The card tray's hint line (cardHand.ts), for the opening road offer and for an in-run offer. */

/**
 * The opening road offer's hint. When only one road shape fits, the sim deals it beside a tower card borrowed from the
 * opening tower offers rather than alone (DESIGN §4.4), and the hint says the choice.
 */
export function openingRoadHint(cards: readonly Card[]): string {
  return cards.some((c) => c.kind === CardKind.Tower) ? "Road or a tower" : "Pick a road";
}

/**
 * The in-run tray's hint: when this offer has no tower cards, how many offers until one does (DESIGN §4.4 — towers are
 * paced, so the wait is known and worth saying); otherwise the plain instruction.
 */
export function pacingHint(sim: LevelSim, cards: readonly Card[]): string {
  if (cards.some((c) => c.kind === CardKind.Tower)) return "Pick one or SKIP";
  const n = sim.offersUntilTowers;
  return n <= 1 ? "Tower cards next hand" : `Tower cards in ${n} hands`;
}
